var _g, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPay(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "pay",
    xmlns: "http://www.w3.org/2000/svg",
    width: 71.037,
    height: 64.652,
    viewBox: "0 0 71.037 64.652",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_204",
    "data-name": "Group 204",
    transform: "translate(1.176 1.175)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_470",
    "data-name": "Path 470",
    d: "M328,32.219h15.282v3.526H328Zm0,0",
    transform: "translate(-280.98 -28.692)",
    fill: "#bddbff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_471",
    "data-name": "Path 471",
    d: "M328,176.219h15.282v3.526H328Zm0,0",
    transform: "translate(-280.98 -151.533)",
    fill: "#bddbff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_472",
    "data-name": "Path 472",
    d: "M112,104.219h15.281v3.527H112Zm0,0",
    transform: "translate(-96.718 -90.113)",
    fill: "#bddbff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_473",
    "data-name": "Path 473",
    d: "M344,104.219h15.282v3.527H344Zm0,0",
    transform: "translate(-294.629 -90.113)",
    fill: "#bddbff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_474",
    "data-name": "Path 474",
    d: "M96,32.219h15.281v3.526H96Zm0,0",
    transform: "translate(-83.07 -28.692)",
    fill: "#bddbff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_475",
    "data-name": "Path 475",
    d: "M96,176.219h15.281v3.526H96Zm0,0",
    transform: "translate(-83.07 -151.533)",
    fill: "#bddbff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_476",
    "data-name": "Path 476",
    d: "M19.755,272.219H8v23.51H19.755Zm0,0",
    transform: "translate(-8 -233.427)",
    fill: "#bddbff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_477",
    "data-name": "Path 477",
    d: "M328,152.219v3.526h15.282v-3.526Zm0,0",
    transform: "translate(-280.98 -131.06)",
    fill: "#bddbff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_478",
    "data-name": "Path 478",
    d: "M328,200.219h15.282v3.527H328Zm0,0",
    transform: "translate(-280.98 -172.007)",
    fill: "#bddbff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_479",
    "data-name": "Path 479",
    d: "M111.281,152.219H96v3.526h15.281Zm0,0",
    transform: "translate(-83.07 -131.06)",
    fill: "#bddbff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_480",
    "data-name": "Path 480",
    d: "M96,200.219h15.281v3.527H96Zm0,0",
    transform: "translate(-83.07 -172.007)",
    fill: "#bddbff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_481",
    "data-name": "Path 481",
    d: "M344,80.219v3.527h15.282V80.219Zm0,0",
    transform: "translate(-294.629 -69.639)",
    fill: "#bddbff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_482",
    "data-name": "Path 482",
    d: "M344,131.745h15.282v-3.526H344Zm0,0",
    transform: "translate(-294.629 -110.586)",
    fill: "#bddbff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_483",
    "data-name": "Path 483",
    d: "M127.281,80.219H112v3.527h15.281Zm0,0",
    transform: "translate(-96.718 -69.639)",
    fill: "#bddbff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_484",
    "data-name": "Path 484",
    d: "M127.281,131.745v-3.526H112v3.526Zm0,0",
    transform: "translate(-96.718 -110.586)",
    fill: "#bddbff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_485",
    "data-name": "Path 485",
    d: "M328,8.219h15.282v3.527H328Zm0,0",
    transform: "translate(-280.98 -8.219)",
    fill: "#bddbff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_486",
    "data-name": "Path 486",
    d: "M328,59.745h15.282V56.219H328Zm0,0",
    transform: "translate(-280.98 -49.166)",
    fill: "#bddbff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_487",
    "data-name": "Path 487",
    d: "M96,8.219h15.281v3.527H96Zm0,0",
    transform: "translate(-83.07 -8.219)",
    fill: "#bddbff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_488",
    "data-name": "Path 488",
    d: "M111.281,59.745V56.219H96v3.527Zm0,0",
    transform: "translate(-83.07 -49.166)",
    fill: "#bddbff"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_489",
    "data-name": "Path 489",
    d: "M70.491,268.7a5.864,5.864,0,0,0-7.8-2.839l-15.231,7.092a5.878,5.878,0,0,0-5.138-8.73H24.685a8.212,8.212,0,0,0-7.43,4.7H14.106v-3.527a1.176,1.176,0,0,0-1.175-1.175H1.175A1.176,1.176,0,0,0,0,265.395V288.9a1.175,1.175,0,0,0,1.176,1.175H12.93a1.175,1.175,0,0,0,1.175-1.175v-2.351H44.8a5.917,5.917,0,0,0,2.483-.55l20.369-9.495a5.9,5.9,0,0,0,2.836-7.813ZM11.755,287.729h-9.4V266.57h9.4ZM66.66,274.38l-20.369,9.492a3.536,3.536,0,0,1-1.488.33h-30.7V271.272h3.938a1.174,1.174,0,0,0,1.109-.789,5.853,5.853,0,0,1,5.532-3.913H42.318a3.526,3.526,0,1,1,0,7.053H31.738v2.351H45.227a5.91,5.91,0,0,0,2.479-.549l15.976-7.439a3.513,3.513,0,0,1,4.673,1.691,3.6,3.6,0,0,1,.329,1.5,3.548,3.548,0,0,1-2.024,3.2Zm0,0",
    transform: "translate(0 -225.428)",
    fill: "#002173"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_490",
    "data-name": "Path 490",
    d: "M89.176,34.308h49.371a1.175,1.175,0,0,0,1.175-1.176v-9.4H140.9a1.175,1.175,0,0,0,1.176-1.175V11.974A1.176,1.176,0,0,0,140.9,10.8h-1.176v-9.4A1.176,1.176,0,0,0,138.547.219H89.176A1.176,1.176,0,0,0,88,1.394V11.974a1.175,1.175,0,0,0,1.176,1.176h1.175v8.228H89.176A1.176,1.176,0,0,0,88,22.553V33.133A1.175,1.175,0,0,0,89.176,34.308ZM92.7,16.676h12.931v1.176H92.7ZM90.351,10.8V9.623h12.931V10.8Zm12.931-3.527H90.351V6.1h12.931Zm0,21.159H90.351V27.255h12.931ZM90.351,30.782h12.931v1.175H90.351Zm47.02-23.51h-12.93V6.1h12.93Zm1.176,5.878h1.175v1.175h-12.93V13.149Zm-11.755,3.526h12.93v1.176h-12.93Zm-2.351,10.579h12.93v1.175h-12.93Zm12.93,4.7h-12.93V30.782h12.93Zm0-7.053h-12.93V23.729h12.93Zm2.351-3.527h-12.93V20.2h12.93ZM124.441,10.8V9.623h12.93V10.8Zm12.93-7.053h-12.93V2.57h12.93ZM122.09,10.8h-1.175v2.351h3.527v8.228h-3.527v2.351h1.175v8.229H105.633V23.729h3.527V21.378h-1.176V13.149h1.176V10.8h-3.527V2.57H122.09ZM90.351,2.57h12.931V3.745H90.351Zm14.106,10.58h1.175v1.175H92.7V13.149ZM92.7,20.2h12.931v1.176H92.7Zm-2.351,3.527h12.931V24.9H90.351Zm0,0",
    transform: "translate(-75.069 -0.219)",
    fill: "#002173"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_491",
    "data-name": "Path 491",
    d: "M250.351,85.149v1.176H252.7V85.149a2.351,2.351,0,0,0,2.351-2.351V80.448A2.351,2.351,0,0,0,252.7,78.1h-2.351V75.745H252.7v1.175h2.351V75.745a2.351,2.351,0,0,0-2.351-2.351V72.219h-2.351v1.175A2.351,2.351,0,0,0,248,75.745V78.1a2.351,2.351,0,0,0,2.351,2.351H252.7V82.8h-2.351V81.623H248V82.8A2.351,2.351,0,0,0,250.351,85.149Zm0,0",
    transform: "translate(-211.559 -61.639)",
    fill: "#002173"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPay);
export default __webpack_public_path__ + "static/media/pay.f171fa0744f3883a9ab034717f69ef48.svg";
export { ForwardRef as ReactComponent };